import React from 'react';

import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';
import { toCurrency, calculateExchangeRate } from '@common/utils/index';

const InsuranceAmount = props => {
  const { premium = 0, currencyUsdYN = 'N', exchangeRate = '' } = props;

  return (
    <div className="wrap-insurance">
      <div className="wrap-inp-cost">
        <div className="box-insurance">
          <span className="tit">보험료</span>
          <span className="txt-cost">
            {toCurrency(premium, currencyUsdYN === 'Y' ? 2 : 0)}
          </span>
          <span className="txt">{currencyUsdYN === 'Y' ? '달러' : '원'}</span>
        </div>
        {currencyUsdYN === 'Y' && parseInt(premium) !== 0 && (
          <SatValidationErrMsg
            visible={true}
            type={'info'}
            message={`${calculateExchangeRate(
              premium,
              exchangeRate,
            )}원 (오늘기준환율 ${exchangeRate}원/달러)`}
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(InsuranceAmount);
